<template>
  <b-row :key="componentKey">
    <b-col md="4">
      <b-card>
       <h5> Estabelecimentos </h5>
        <div v-if="data.merchants && data.merchants.length">
          <div
            v-for="(item, index) in data.merchants"
            :key="index"
          >
            <b-row
              v-if="merchantsMap.get(item)"
              class="px-1 justify-content-between align-items-center"
            >
              <p class="m-0">
                {{ merchantsMap.get(item).name }} -
                {{ merchantsMap.get(item).veripag_id }}
              </p>
              <b-button
                v-if="!update"
                class="clickable remove"
                variant="transparent"
                @click="removeMerchant(merchantsMap.get(item))"
              >
                <feather-icon
                  icon="Trash2Icon"
                  size="18"
                />
              </b-button>

            </b-row>
          </div>
        </div>
        
        <div v-else>
          <p>Não possui estabelecimentos selecionados</p>
        </div>
      </b-card>
    </b-col>

    <b-col md="8">
      <b-card>
        <b-form>
          <b-form-group label-for="name" label="Nome">
            <b-form-input id="name" v-model="data.name" placeholder="Nome" />
          </b-form-group>

          <b-form-group label-for="merchantCode" label="Estabelecimento">
            <b-input-group>
              <b-form-input
                id="merchantCode"
                v-model="merchantCode"
                placeholder="Digite o número do Estabelecimento"
              />
              <template #append>
                <b-button
                  variant="primary"
                  :disabled="merchantCode.trim() === ''"
                  @click="addMerchant"
                >
                  Adicionar
                </b-button>
              </template>
            </b-input-group>
          </b-form-group>

          <slot name="append-form" />
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
    BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BButton, BFormSelect, BInputGroup,
} from 'bootstrap-vue';

export default {
    components: {
        BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BButton, BFormSelect, BInputGroup,
    },

  props: {
    data: {
      type: Object,
      required: true,
    },

    merchants: {
      type: Array,
      default: () => [],
    },

    update: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      merchantCode: "",
      componentKey: 1,
      merchantsOptionsData: JSON.parse(JSON.stringify(this.merchants)),
      merchantsMap: new Map(),
    };
  },

  watch: {
    merchants: {
      immediate: true,
      handler(newVal) {
        this.merchantsMap = new Map();
        this.merchantsOptionsData = [];

        newVal.forEach((merchant) => {
          this.merchantsMap.set(merchant.id, merchant);
          if (!this.data.merchants?.includes(merchant.id)) {
            this.merchantsOptionsData.push(merchant);
          }
        });

        this.componentKey++;
      },
    },
  },

  methods: {
    addMerchant() {
      const code = this.merchantCode.trim();

      if (!code) return;

      const found = this.merchants.find(
        (merchant) => String(merchant.veripag_id) === String(code)
      );

      if (!found) {
        this.$bvToast?.toast(
          "Código não encontrado na lista de estabelecimentos.",
          {
            title: "Erro",
            variant: "danger",
            solid: true,
          }
        );
        return;
      }

      if (this.data.merchants.includes(found.id)) {
        this.$bvToast?.toast("Este estabelecimento já foi adicionado.", {
          title: "Aviso",
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.data.merchants.push(found.id);
      this.merchantsOptionsData = this.merchantsOptionsData.filter(
        (m) => m.id !== found.id
      );
      this.merchantCode = "";
    },

    removeMerchant(data) {
      const index = this.data.merchants.findIndex((id) => id === data.id);
      if (index !== -1) {
        this.data.merchants.splice(index, 1);
        this.merchantsOptionsData.push(data);
      }
    },
  },
};
</script>

<style>
.remove:hover * {
  cursor: pointer;
  color: #ea5455;
}
</style>
